import React, {useState, useRef, useEffect} from 'react';
import {MoreVerticalIcon} from 'pages/DeliveryPlanner/components/OrderDetailsModal/icons';
import styles from './ActionMenuPopup.module.scss';

interface ActionMenuPopupProps {
  onDeleteOrder?: () => void;
}

const ActionMenuPopup: React.FC<ActionMenuPopupProps> = ({onDeleteOrder}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleAction = (action: () => void) => {
    action();
    setIsOpen(false);
  };

  return (
    <div className={styles.container} ref={menuRef}>
      <button
        className={styles.triggerButton}
        onClick={handleToggle}
        aria-label="Open action menu"
      >
        <MoreVerticalIcon width={20} height={20} color="#666" />
      </button>

      {isOpen && (
        <div className={styles.popup}>
          <div className={styles.popupContent}>
            <div
              className={styles.item}
              onClick={() => onDeleteOrder && handleAction(onDeleteOrder)}
            >
              {/* <Trash2Icon width={16} height={16} /> */}
              <span className={styles.itemText}>Delete Order</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionMenuPopup;
